import { RouterProvider } from "react-router-dom";
import router from "./routes";
import { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { CookieManager } from "react-cookie-manager"; // react-cookie-manager
import Cookies from "js-cookie";
import { CookieContext } from "./components/context/CookieContext";

const cookieMessage = `
  We use cookies to better understand how you use our website and to improve
  and personalize your experience. For detailed information please see our
  <a href="/privacy-policy-and-cookie-usage" style="color: #3a52e6; text-decoration: underline; margin-left: 4px;">
    Privacy Policy and Cookie Usage
  </a>.
`;

function App() {
  const [cookiePermission, setCookiePermission] = useState(
    () => Cookies.get("px_cookie_permission") || "1"
  );

  const iframeRef = useRef(null);

  const applyConsent = (consent) => {
    const hasPermission = consent === "1";


    if (hasPermission) {
      if (!iframeRef.current) {
        const iframe = document.createElement("iframe");

        iframe.src = "https://static.pixad.com.tr/sync.html";
        iframe.width = "0";
        iframe.height = "0";
        iframe.style.display = "none";

        document.body.appendChild(iframe);
        iframeRef.current = iframe;
      }
    } else {
      if (iframeRef.current) {
        document.body.removeChild(iframeRef.current);
        iframeRef.current = null;
      }

      Cookies.remove("uids", { domain: ".pixad.com.tr", path: "/" });
    }
  };

  useEffect(() => {
    const saved = Cookies.get("px_cookie_permission");
    if (saved) {
      try {
        setCookiePermission(saved);
        applyConsent(saved);
      } catch (e) {
        console.error("Consent parse error", e);
      }
    }
  }, []);

  const handleConsent = (consent) => {
    Cookies.set("px_cookie_permission", consent, { expires: 365 });
    setCookiePermission(consent);
    applyConsent(consent);
  };

  return (
    <CookieContext.Provider value={{ cookiePermission, setCookiePermission }}>
      <Helmet>
        <title>Pixad</title>
        <meta name="description" content="Pixad is a creative powerhouse!" />
        <link rel="icon" href="favicon.svg" />
      </Helmet>
      <CookieManager
        disableAutomaticBlocking={true}
        classNames={{
          poweredByLink: "hidden",
        }}
        cookieCategories={{
          Analytics: false,
          Social: false,
          Advertising: false
        }}
        translations={{
          title: "Cookie Preferences",
          message: <span dangerouslySetInnerHTML={{ __html: cookieMessage }} />,
        }}
        onAccept={() => handleConsent("1")}
        onDecline={() => handleConsent("0")}
        disableGeolocation
      >
        <RouterProvider router={router} />
      </CookieManager>
    </CookieContext.Provider>
  );
}

export default App;